<template>
  <div>
    <my-breadcrumb :items="pagination"></my-breadcrumb>
    <div class="dashboard-page-container">
      <h4>{{video.name}}</h4>

      <div class="youtube-video-container mt-2 mb-5">
        <div id="video-player" style="width:850px;max-width:100%;height:auto;"></div>
        <div id="script-player"></div>
        <input type="text" id="video-otp" style="display: none">
        <input type="text" id="video-playback" style="display: none">
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import { mapGetters, mapActions } from "vuex";
  import * as types from "@/store/types";

  export default {
    data() {
      return {
        pagination: [],
        video:{}
      }
    },
    computed: {
      ...mapGetters({
        isLoggedIn: types.IS_LOGGED_IN  
      })
    },
    watch: {
      $route: function(newVal) {
        this.getDetail();
      }
    },
    mounted() {
      if(this.isLoggedIn) {
        this.getDetail();
      } else {
        var link = "/login"
        if(this.$route.params.section) {
          link += "?section=" + this.$route.params.section
        }
        this.$router.push(link);
      }
    }, 
    methods: {
      ...mapActions({
        getContentDetail: types.GET_CONTENT_DETAIL
      }),
      getDetail() {
        this.getContentDetail(this.$route.params.id)
        .then(response => {
          this.video = response[0];
          console.log(this.video);
          this.pagination = [
            {
              text: this.video.level,
              url: '#'
            },
            {
              text: this.video.class + " "+ this.video.major ? this.video.class : "",
              url: '#'
            },
            {
              text: this.video.subject,
              url: '#'
            },
            {
              text: this.video.curriculum,
              url: '#'
            },
            {
              text: this.video.chapter,
              url: '#'
            },{
              text: this.video.section,
              url: '#'
            }
          ];
          this.setVideo();
        }).catch(error => {
          this.showMessageBox(error, "Failed to get contents", "danger");
        })
      },
      showMessageBox(message, title, variant) {
        this.$bvModal.msgBoxOk(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: variant,
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
        .then(value => {
          this.temp = value
        })
        .catch(err => {
          this.temp = err;
        });
      },
      setVideo() {
        let videoPlayer = document.getElementById("video-player");
        let scriptPlayer = document.getElementById("script-player");
        videoPlayer.html = '';
        scriptPlayer.html = '';

        axios.get("https://api.alfathbelajar.com/video/get-otp?id="+this.video.player_id)
        .then((response) => {
          if(response.data && response.data.status == 200) {
            document.getElementById("video-otp").value = response.data.data.otp;
            document.getElementById("video-playback").value = response.data.data.playbackInfo;

            let script = document.createElement('script');
            script.setAttribute('src', '/player.js'); // file at public folder
            document.getElementById("script-player").appendChild(script)
          } else {
            this.showMessageBox(response.data.message, "Failed to get contents", "danger");
          }
        })
        .catch((error) => {
          this.showMessageBox(error, "Failed to get contents", "danger");
        });
      }
    }
  }
</script>